import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
export function HeaderActions() {
  return <div className="hidden lg:flex flex-col items-end gap-1 shrink-0" data-id="element-310">
      <div className="flex items-center gap-3" data-id="element-311">
        <a href="tel:517-220-0621" aria-label="Call Storm Taekwondo at 517-220-0621" className="flex items-center text-ink hover:text-storm-red transition-colors" data-id="element-312">
          <Phone className="w-5 h-5 shrink-0" data-id="element-313" />
        </a>
        <Link to="/SignMeUp" className="btn-primary py-2 px-4 text-sm whitespace-nowrap" data-id="element-314">
          Start Trial Class
        </Link>
      </div>
      <a href="tel:517-220-0621" className="text-xs font-bold text-gray-warm hover:text-storm-red transition-colors tracking-wide" data-id="element-315">
        Call 517-220-0621
      </a>
    </div>;
}